import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const SelectCancelIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        style={customStyle}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="1.8" />

        <path d="M8 7L8.8 15L11.2 12.6L13 16L14.6 15.2L12.8 11.9L16 11L8 7Z" fill="currentColor" />

        <path
          d="M15.5 15.5L18.5 18.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
        <path
          d="M18.5 15.5L15.5 18.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default SelectCancelIcon;
